module.exports = __webpack_public_path__ + "assets/images/hero@2x-3886a2da0f977066953c57b36f1cc6bd.jpg";